import { borderBottom } from "@mui/system";
import React from "react";
import { Link } from "react-router-dom";
import BlogCard from "../../../Common/BlogCard";
import { RenderPrice } from "../../../Common/Function";
import Loading from "../../../Common/Loading";

function WhyUs({ data = [], landingLoading }) {
  if (landingLoading) {
    return (
      <section className="padding-y-section border-bottom-section border-top-section why-us">
        <div className="container">
          <div className="row">
            <Loading count={2} col={6} height={500} />
          </div>
        </div>
      </section>
    );
  }
  if (data.length == 0) {
    return <></>;
  }
  return (
    <section className="padding-y-section border-bottom-section border-top-section why-us">
      <div className="container">
        <div className="row">
          <div className="d-flex justify-content-between align-items-center p-1">
            <div>
              <h4 className="most-seen-title" style={{ color: "#404040" }}>
                <img
                  src={window.origin + "/WebSide/assets/images/view.png"}
                  alt="مقالات پربازدید"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginLeft: "10px",
                  }}
                />
                تازه های مجله
              </h4>
            </div>
            <div>
              <Link
                to={"/weblog"}
                style={{
                  color: "#404040",
                  fontWeight: "400",
                  fontSize: "14px",
                  borderBottom: "1px solid #E42A3F",
                  marginLeft: "20px",
                }}
                className="p-1 btn"
              >
                مشاهده همه
              </Link>
            </div>
          </div>
        </div>
        <div className="row">
          {data.map((blog, key) => {
            return <BlogCard blog={blog} key={key} />;
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
